/**
 * Created by wjjn3481 on 2017/6/12.
 * 实现position:sticky(目前还没有支持的css效果)的效果
 */

const VueSticky = {
    id: 'Sticky',
    name: 'directive-sticky',
    bind (el, binding, vnode) {
        el.handleScroll = function (e) {
            if (el.style.position === 'initial') {
                if (window.scrollY >= el.offsetTop) {
                    el.style.position = 'fixed'
                    el.style.top = 0
                    el.style.width = '100%'
                    el.style.zIndex = 1000
                }
            } else {
                // 因为当前元素el已经脱离正常文档流，所以要减去el的高度
                if ((window.scrollY - el.offsetHeight) < el.offsetTop) {
                    el.style.position = 'initial'
                    el.style.top = 'initial'
                    el.style.width = 'initial'
                    el.style.zIndex = 'initial'
                }
            }
        }
        window.addEventListener('scroll', el.handleScroll)
    },
    unbind (el) {
        window.removeEventListener('scroll', el.handleScroll)
    },
    install (Vue) {
        Vue.directive(this.id, {
            bind: this.bind,
            unbind: this.unbind
        })
    }
}

export default VueSticky


// WEBPACK FOOTER //
// ./src/directives/vue-sticky.js